import Login from '../../views/user/Login';
import ResetPasswordRequest from '../../views/user/ResetPasswordRequest';
import ConfirmResetPassword from "../../views/user/ConfirmResetPassword";
import GeneralConditionsOfUsage from "../../views/GeneralConditionsOfUsage";
import ExternalGeneralConditionsOfUsage from "../../views/ExternalGeneralConditionsOfUsage";
import ContactUs from "@/views/user/ContactUs";
import FirstUserLogin from "@/views/user/FirstUserLogin";
import MaintenanceMode from "@/views/MaintenanceMode";
import { loginGuard } from '../guard';

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: loginGuard
    },
    {
        path: '/password-reset',
        name: 'reset-password',
        component: ResetPasswordRequest
    },
    {
        path: '/password-reset/:resetPasswordToken',
        name: 'reset-password-confirm',
        component: ConfirmResetPassword
    },
    {
        path: '/general-usage-conditions',
        name: 'general-usage-conditions',
        component: GeneralConditionsOfUsage
    },
    {
        path: '/external-general-usage-conditions',
        name: 'external-general-usage-conditions',
        component: ExternalGeneralConditionsOfUsage
    },
    {
        path: '/contact-us',
        name: 'contact-us',
        component: ContactUs
    },
    {
        path: '/first-user-login/:resetPasswordToken',
        name: 'first-user-login',
        component: FirstUserLogin
    },
    {
        path: '/maintenance-mode',
        name: 'maintenance-mode',
        component: MaintenanceMode
    },
];
